module.exports = __webpack_public_path__ + "static/media/LifeLine6.f0573dd2.png";